import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const CardHeading = (_param)=> {
    var { className , variant ='smallest' , children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "variant",
        "children"
    ]);
    return React.createElement(Heading, swcHelpers.extends({
        variant: variant,
        className: classnames('card-heading', className)
    }, rest), children);
};
var CardHeading$1 = CardHeading;

export { CardHeading$1 as default };
//# sourceMappingURL=CardHeading.js.map
